import Vue from "vue";
import store from "../index";

class BaseClass {
  constructor(data, skip_embedded = false) {
    Object.assign(this, data);

    if (typeof skip_embedded === "boolean" && skip_embedded) {
      return;
    }
    skip_embedded instanceof Array || (skip_embedded = []);

    if (typeof this._embedded !== "undefined") {
      for (let i in this._embedded) {
        if (skip_embedded.includes(i)) {
          continue;
        }
        let t;
        try {
          t = require(`./${i.charAt(0).toUpperCase() +
            i.substr(1, i.length - 1)}`).default;
        } catch (e) {
          continue;
        }
        if (typeof t === "undefined") {
          continue;
        }

        if (this._embedded[i] instanceof Array) {
          this._embedded[i] = t.getSelfList(this._embedded[i]);
        } else {
          !this._embedded[i] || (this._embedded[i] = new t(this._embedded[i]));
        }
      }
    }
  }

  get _name() {
    return this.constructor.toString().match(/function ([^(]+)/)[1];
  }

  set _name(v) {}

  get _store() {
    return store;
  }

  get _locale() {
    return store.getters["locale"];
  }

  get schema() {
    return this.constructor.schema;
  }

  static getSelfList(dataList, skip_embedded = false) {
    if (dataList instanceof Array) {
      return dataList.map(v => {
        return new this(v, skip_embedded);
      });
    }

    return [new this(dataList)];
  }

  static get _api() {
    return Vue.prototype.$api;
  }

  get _api() {
    return Vue.prototype.$api;
  }

  get _confirm() {
    return Vue.prototype.$confirm;
  }

  get _notify() {
    return Vue.prototype.$notify;
  }

  get _set() {
    return Vue.prototype.$set;
  }

  get _delete() {
    return Vue.prototype.$delete;
  }

  static get _log() {
    return Vue.prototype.$log;
  }

  get _log() {
    return Vue.prototype.$log;
  }
}

export default BaseClass;
